import { type ForwardedRef, useCallback, useRef } from 'react'
function useForwardedRef<T>(ref?: ForwardedRef<T>) {
  const localRef = useRef<T | null>(null)
  const forwardedRef: ForwardedRef<T> = useCallback(
    (instance: T | null) => {
      localRef.current = instance
      if (!ref) return
      if (typeof ref === 'function') return ref(instance)
      ref.current = instance
    },
    [ref]
  )
  return [localRef, forwardedRef] as const
}

export default useForwardedRef
